export default __webpack_public_path__ + "static/media/cny-mobile-bg.47fdf8b5.webp";